import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar } from 'redux/navigation'
import { Dropdown } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      hideSidebar,
    },
    dispatch
  )
}

class NavigationDropdown extends React.Component {
  render() {
    // props
    const { items, customProps = {} } = this.props

    // actions
    const { push, hideSidebar } = this.props

    const options = items.map((item) => ({
      active: item.active,
      content: item.name,
      href: item.path,
      value: item.key,
      size: 'small',
      onClick: (event) => {
        event.preventDefault()
        push(item.path)
        hideSidebar()
      },
    }))

    return <Dropdown {...customProps} options={options} />
  }
}

NavigationDropdown = connect(mapStateToProps, mapDispatchToProps)(
  NavigationDropdown
)
export default NavigationDropdown



// WEBPACK FOOTER //
// ./src/components/shared/Navigation/renditions/NavigationDropdown.jsx